import React from 'react'

export default function Notfound() {
  return (
    <>
      <div className="container">
        <div className="row  not-found">
          <h3 className="pt-5">Unhandled Thrown Error!<br/>
            404 Not Found</h3>
            <p>💿 Hey developer 👋</p>
            <p>You can provide a way better UX than this when your app throws errors by providing your own errorElement props on</p>
        </div>
      </div>
    </>
  )
}
